import { render } from "./ChampionsPage.vue?vue&type=template&id=b35f0fb2&scoped=true"
import script from "./ChampionsPage.vue?vue&type=script&lang=js"
export * from "./ChampionsPage.vue?vue&type=script&lang=js"

import "./ChampionsPage.vue?vue&type=style&index=0&id=b35f0fb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b35f0fb2"]])

export default __exports__